module.exports = __webpack_public_path__ + "img/modal-close.bb1df7cd.svg";